import { handleActions, createAction } from 'redux-actions';
import { cloneDeep, get } from 'lodash';
import { ACCEPTED, BROWSE, MY_BETS, IN_REALIZATION, SOLD,
  NEW_BETS, LOST_AUCTIONS, ADS, BUY_NOW } from '../consts/navigation';

export const TOGGLE_SORT = createAction('TOGGLE/SORT');
export const SET_PAGE = createAction('SET/PAGE');
export const SET_ROWS_PER_PAGE = createAction('SET/ROWS/PER/PAGE');
export const SET_SEARCH_QUERY = createAction('SET/SEARCH/QUERY');
export const SET_COUNTRIES = createAction('SET/COUNTRIES');

const initialState = {
  [BROWSE]: {},
  [BUY_NOW]: {},
  [MY_BETS]: {},
  [IN_REALIZATION]: {},
  [ACCEPTED]: {},
  [SOLD]: {},
  [NEW_BETS]: {},
  [LOST_AUCTIONS]: {},
  [ADS]: {},
  invoices: {},
};


const TableReducer = handleActions(
  {
    [SET_ROWS_PER_PAGE]: (state, { payload: { rowsPerPage, tableName, }, }) => {
      const newState = cloneDeep(state);
      newState[tableName].rowsPerPage = rowsPerPage;
      newState[tableName].page = 1;
      return newState;
    },

    [SET_PAGE]: (state, { payload: { page, tableName, }, }) => {
      const newPage = (page > 0 ? page : 1);
      const newState = cloneDeep(state);
      newState[tableName].page = newPage;
      return newState;
    },
    [TOGGLE_SORT]: (state, { payload: { tableName, sortBy, }, }) => {
      const currentSortOrder = get(state, [tableName, 'sort', 'order']);
      const currentSortBy = get(state, [tableName, 'sort', 'sortBy']);

      // asc -> desc -> null -> asc -> ...
      let newSort = {};
      if (!currentSortOrder || sortBy !== currentSortBy) {
        newSort = {
          sortBy,
          order: 'asc',
        };
      } else if (currentSortOrder === 'desc') {
        newSort = {
          sortBy: null,
          order: null,
        };
      } else if (currentSortOrder === 'asc') {
        newSort = {
          sortBy,
          order: 'desc',
        };
      }
      const newState = cloneDeep(state);
      newState[tableName].sort = newSort;
      newState[tableName].page = 1;
      return newState;
    },
    [SET_SEARCH_QUERY]: (state, { payload: { tableName, queryValue, }, }) => {
      const newState = cloneDeep(state);
      newState[tableName].queryValue = queryValue;
      newState[tableName].page = 1;
      return newState;
    },

    [SET_COUNTRIES]: (state, { payload: { countries, tableName, }, }) => {
      const newState = cloneDeep(state);
      newState[tableName].countries = countries;
      newState[tableName].page = 1;
      return newState;
    },
  },
  initialState
);

export default TableReducer;
